
import AirplaneSquare from "../../../assets/duotone/AirplaneSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AirplaneSquareIcon({ className, dataTestid = "AirplaneSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AirplaneSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
